import ModalPopup from './ModalPopup';
export default ModalPopup;
